import { lazy } from 'react';
import Loadable from '@/components/base-component/Loadable';

//============ Page Components ===============
const MaintenanceError = Loadable(lazy(() => import('@/pages/examples/maintenance/error/404')));
const MaintenanceError500 = Loadable(lazy(() => import('@/pages/examples/maintenance/error/500')));
const MaintenanceUnderConstruction = Loadable(lazy(() => import('@/pages/examples/maintenance/under-construction/under-construction')));
const MaintenanceUnderConstruction2 = Loadable(lazy(() => import('@/pages/examples/maintenance/under-construction/under-construction2')));
const MaintenanceComingSoon = Loadable(lazy(() => import('@/pages/examples/maintenance/coming-soon/coming-soon')));
const MaintenanceComingSoon2 = Loadable(lazy(() => import('@/pages/examples/maintenance/coming-soon/coming-soon2')));

export const maintainanceRoutes = [
  {
    path: '', // default
    element: <MaintenanceError />
  },
  {
    path: '404',
    element: <MaintenanceError />
  },
  {
    path: '500',
    element: <MaintenanceError500 />
  },
  {
    path: 'under-construction',
    element: <MaintenanceUnderConstruction />
  },
  {
    path: 'under-construction2',
    element: <MaintenanceUnderConstruction2 />
  },
  {
    path: 'coming-soon',
    element: <MaintenanceComingSoon />
  },
  {
    path: 'coming-soon2',
    element: <MaintenanceComingSoon2 />
  }
];
